module.exports = __webpack_public_path__ + "static/media/DSC05705.e465bd07.jpg";